import { CustomDenomination, Denomination } from './denomination.model';
import { Vendor } from './vendor.model';

export enum ETagProduct {
  ZM = 'ZipMoney',
  ZP = 'ZipPay',
}

export enum ETagProductNameMapping {
  ZipMoney = 'Zip Money',
  ZipPay = 'Zip Pay',
}

export enum ETagType {
  CASHBACK = 'CASHBACK',
  PLAIN = 'PLAIN',
}

export class CheckoutInfo {
  result: string;
  checkoutId: string;
  productId: string;
  name?: string;
  email: string;
  giftcard: GiftCard;
}

export interface Tag {
  type: ETagType;
  text: string;
  products: ETagProduct[];
}

export interface IGiftCard {
  vendor?: Vendor;
  id?: string;
  brand?: string;
  image?: string;
  denominations?: Denomination[];
  position?: number;
  terms?: string;
  importantContent?: string;
  termsLink?: string;
  discount?: number;
  isFixedValue?: boolean;
  cardTypeStatus?: string;
  keywords?: string;
  tags?: Tag[];
}

export class GiftCard implements IGiftCard {
  constructor(
    public vendor?: Vendor,
    public id?: string,
    public brand?: string,
    public image?: string,
    public denominations: Denomination[] = [],
    public position?: number,
    public terms?: string,
    public disclaimer?: string,
    public termsLink?: string,
    public discount?: number,
    public merchantUniqueId?: string,
    public merchantId?: string,
    public isFixedValue?: boolean,
    public importantContent?: string,
    public cardTypeStatus?: string,
    public cashBack?: string,
    public tags: Tag[] = [],
  ) {}
}

export interface GiftCardV2 {
  vendor?: Vendor;
  id?: string;
  brand?: string;
  image?: string;
  denominations: Denomination[];
  position?: number;
  terms?: string;
  disclaimer?: string;
  termsLink?: string;
  discount?: number;
  merchantUniqueId?: string;
  merchantId?: string;
  isFixedValue?: boolean;
  importantContent?: string;
  cardTypeStatus?: string;
  cashBack?: string;
  tags: Tag[];
  customDenominations: CustomDenomination[];
  featured?: boolean;
}

export interface IGiftCardSearch {
  vendor?: Vendor;
  id?: string;
  brand?: string;
  image?: string;
  denominations?: Denomination[];
  terms?: string;
  importantContent?: string;
  termsLink?: string;
  discount?: number;
  isFixedValue?: boolean;
  keywords?: string;
}
export class GiftCardSearch implements IGiftCardSearch {
  constructor(
    public vendor?: Vendor,
    public id?: string,
    public brand?: string,
    public image?: string,
    public denominations: Denomination[] = [],
    public terms?: string,
    public termsLink?: string,
    public discount?: number,
    public isFixedValue?: boolean,
    public importantContent?: string,
    public keywords?: string,
  ) {}
}
